export class ThemeColorsModel {
  public primary: string = '';
  public accent: string = '';
}
